import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { GoogleMap, Marker, LoadScript, StandaloneSearchBox } from '@react-google-maps/api';

const libraries = ['geometry', 'drawing', 'places'];

const SearchBoxMap = ({
  bounds,
  center,
  position,
  zoom,

  onBoundsChanged,
  onDragEnd,
  onMapMounted,
  onPlacesChanged,
  onSearchBoxMounted,
  onClick,
}) => {
  const intl = useIntl();

  return (
    <LoadScript googleMapsApiKey={process.env.REACT_APP_GMAP_KEY} libraries={libraries}>
      <GoogleMap
        onLoad={onMapMounted}
        options={{
          mapTypeControl: false,
          fullscreenControl: false,
          streetViewControl: false,
        }}
        defaultZoom={7}
        zoom={zoom}
        center={center}
        onBoundsChanged={onBoundsChanged}
        mapContainerStyle={{ minHeight: '50vh' }}
        onClick={onClick}
      >
        <StandaloneSearchBox
          onLoad={onSearchBoxMounted}
          bounds={bounds}
          onPlacesChanged={onPlacesChanged}
        >
          <input
            type="text"
            placeholder={intl.formatMessage({
              id: 'Search',
              defaultMessage: 'Search',
            })}
            style={{
              boxSizing: 'border-box',
              border: '1px solid transparent',
              width: '250px',
              height: '42px',
              padding: '0 12px',
              borderRadius: '3px',
              boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
              fontSize: '16px',
              outline: 'none',
              textOverflow: 'ellipses',
              position: 'absolute',
              right: '10px',
              top: '10px',
              marginLeft: '-120px',
            }}
            onClick={(e) => {
              e.stopPropagation();
            }}
          />
        </StandaloneSearchBox>
        {position && position.lat && <Marker draggable position={position} onDragEnd={onDragEnd} />}
      </GoogleMap>
    </LoadScript>
  );
};

SearchBoxMap.propTypes = {
  bounds: PropTypes.shape({}),
  center: PropTypes.shape({
    lat: PropTypes.number.isRequired,
    lng: PropTypes.number.isRequired,
  }),
  position: PropTypes.shape({
    lat: PropTypes.number,
    lng: PropTypes.number,
  }).isRequired,
  zoom: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  onBoundsChanged: PropTypes.func.isRequired,
  onDragEnd: PropTypes.func.isRequired,
  onMapMounted: PropTypes.func.isRequired,
  onSearchBoxMounted: PropTypes.func.isRequired,
  onPlacesChanged: PropTypes.func.isRequired,
};

export default SearchBoxMap;
